import { useEffect, useState } from 'react';
import Loading from '../components/UI/Loading';

import QuotationsCard from "../components/QuotationsCard";
import AssetCard from '../components/UI/AssetCard';

function HomePage() {

    const [isLoading, setIsLoading] = useState(true);
    const [altasAcoes, setAltasAcoes] = useState([]);
    const [baixasAcoes, setBaixasAcoes] = useState([]);
    const [altasFIIs, setAltasFIIs] = useState([]);
    const [baixasFIIs, setBaixasFIIs] = useState([]);
    const [altasStocks, setAltasStocks] = useState([]);
    const [baixasStocks, setBaixasStocks] = useState([]);
    const [altasETFs, setAltasETFs] = useState([]);
    const [baixasETFs, setBaixasETFs] = useState([]);
    const [altasREITs, setAltasREITs] = useState([]);
    const [baixasREITs, setBaixasREITs] = useState([]);

    useEffect(() => {
        setIsLoading(true);
        async function carregarDestaques(size = 10) {
            const acoesBaseUrl = "https://www.investidorlibertario.terradata.com.br/api/queries/acoes-highlights.php";
            const fiisBaseUrl =  "https://www.investidorlibertario.terradata.com.br/api/queries/fiis-highlights.php";
            const stocksBaseUrl =  "https://www.investidorlibertario.terradata.com.br/api/queries/stocks-highlights.php";     
            const etfsBaseUrl =  "https://www.investidorlibertario.terradata.com.br/api/queries/etfs-highlights.php";  
            const reitsBaseUrl =  "https://www.investidorlibertario.terradata.com.br/api/queries/reits-highlights.php";                         

            try {
                // Iniciamos as duas chamadas ao mesmo tempo
                const [resAltasAcoes, resBaixasAcoes,
                    resAltasFIIs, resBaixasFIIs,
                    resAltasStocks, resBaixasStocks,
                    resAltasETFs, resBaixasETFs,
                    resAltasREITs, resBaixasREITs
                ] = await Promise.all([
                    fetch(`${acoesBaseUrl}?class=1&size=${size}&sort=DESC`),
                    fetch(`${acoesBaseUrl}?class=1&size=${size}&sort=ASC`),
                    fetch(`${fiisBaseUrl}?class=2&size=${size}&sort=DESC`),
                    fetch(`${fiisBaseUrl}?class=2&size=${size}&sort=ASC`),
                    fetch(`${stocksBaseUrl}?class=3&size=${size}&sort=DESC`),
                    fetch(`${stocksBaseUrl}?class=3&size=${size}&sort=ASC`),
                    fetch(`${etfsBaseUrl}?class=4&size=${size}&sort=DESC`),
                    fetch(`${etfsBaseUrl}?class=4&size=${size}&sort=ASC`),
                    fetch(`${reitsBaseUrl}?class=5&size=${size}&sort=DESC`),
                    fetch(`${reitsBaseUrl}?class=5&size=${size}&sort=ASC`)
                ]);

                // Convertemos ambos os resultados para JSON em paralelo também
                const [dataAltasAcoes, dataBaixasAcoes,
                    dataAltasFIIs, dataBaixasFIIs,
                    dataAltasStocks, dataBaixasStocks,
                    dataAltasETFs, dataBaixasETFs,
                    dataAltasREITs, dataBaixasREITs
                ] = await Promise.all([
                    resAltasAcoes.json(),
                    resBaixasAcoes.json(),
                    resAltasFIIs.json(),
                    resBaixasFIIs.json(),
                    resAltasStocks.json(),
                    resBaixasStocks.json(),
                    resAltasETFs.json(),
                    resBaixasETFs.json(),
                    resAltasREITs.json(),
                    resBaixasREITs.json()
                ]);

                // Atualizamos os estados
                setAltasAcoes(dataAltasAcoes);
                setBaixasAcoes(dataBaixasAcoes);
                setAltasFIIs(dataAltasFIIs);
                setBaixasFIIs(dataBaixasFIIs);
                setAltasStocks(dataAltasStocks);
                setBaixasStocks(dataBaixasStocks);
                setAltasETFs(dataAltasETFs);
                setBaixasETFs(dataBaixasETFs);
                setAltasREITs(dataAltasREITs);
                setBaixasREITs(dataBaixasREITs);
                setIsLoading(false);
            } catch (err) {
                console.error("Erro ao carregar destaques:", err);
            }
        }
        carregarDestaques(13);
    }, []);

    return <>
        {isLoading && <Loading />}
        {!isLoading && <>
            <div className="row g-0">
                <div className="col col-md-2 p-1">
                    <QuotationsCard title="Cotações" />
                </div>

                <div className="col col-md-2 p-1">
                    <AssetCard title='Ações' altas={altasAcoes} baixas={baixasAcoes} />
                </div>

                <div className="col col-md-2 p-1">
                    <AssetCard title='FIIs' altas={altasFIIs} baixas={baixasFIIs} />
                </div>

                <div className="col col-md-2 p-1">
                    <AssetCard title='Stocks' altas={altasStocks} baixas={baixasStocks} dolar={true} />
                </div>

                <div className="col col-md-2 p-1">
                    <AssetCard title='ETFs' altas={altasETFs} baixas={baixasETFs} dolar={true} />
                </div>

                <div className="col col-md-2 p-1">
                    <AssetCard title='REITs' altas={altasREITs} baixas={baixasREITs} dolar={true} />
                </div>
            </div>
        </>
        }
    </>
}

export default HomePage;